import { render } from "./AdminConfigView.vue?vue&type=template&id=20d509b1&scoped=true"
import script from "./AdminConfigView.vue?vue&type=script&lang=js"
export * from "./AdminConfigView.vue?vue&type=script&lang=js"

import "./AdminConfigView.vue?vue&type=style&index=0&id=20d509b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d509b1"]])

export default __exports__